import React, { useState, useContext, useEffect } from 'react';
import queryString from 'query-string';

import NewsContext from '../../context/news-context';
import Layout from '../Layout/index';
import NewsList from '../NewsList/index';
import { FilteredText } from './style';

const Filter = ({ location }) => {
    const [filteredNews, setFilteredNews] = useState([]);
    const [filterBy, setFilterBy] = useState('');
    const { news } = useContext(NewsContext);

    useEffect(() => {
        const { query } = queryString.parse(location.search);
        setFilteredNews([]);

        for(let category in news) {
            let matched = news[category].filter(({ title }) => title.toLowerCase().includes(query));
            setFilteredNews((prevState) => [...prevState, ...matched]);
        }

        setFilterBy(query);
    }, [news, location.search]);
    
    return (
        <Layout>
            {
                filterBy ? 
                (
                    <>
                        <FilteredText>Filtered by- {filterBy}</FilteredText>
                        {
                            filteredNews.length > 0
                            ? 
                            <NewsList articles={filteredNews} />
                            :
                            <p>No News Found</p>
                        }
                    </>
                )
                :
                <p>Loading...</p>
            }
        </Layout>
    );
};

export default Filter;